

import React from "react";


const MobileOtp = () =>{
    return(
        <div className="row">
            <div className="col-lg-8 mx-auto">
                <div className="card">
                    <div className="card-header">
                        <h5 className="mb-0">Mobile OTP</h5>
                    </div>
                    <div className="card-block">
                        <div className="row">
                            <div className="col-lg-4">
                                <label className="form-label">OTP</label>
                            </div>
                            <div className="col-lg-8">
                                <div className="form-group mb-4">
                                    <input type="text" className="form-control input-me" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MobileOtp;